<template>
  <div class="scroll-y-container" :style="style">
    <slot />
  </div>
</template>

<script>
export default {
  name: "HcScrollContainer",
  props: {
    alturaMin: {
      type: [Number, String],
      default: 0
    },
    alturaMax: {
      type: [Number, String]
    },
    unidadeAltura: {
      type: String,
      default: "px"
    },
    larguraMin: {
      type: [Number, String],
      default: 100
    },
    larguraMax: {
      type: [Number, String]
    },
    unidadeLargura: {
      type: String,
      default: "%"
    }
  },
  computed: {
    style
  }
};

function style() {
  const style = {
    minWidth: `${this.larguraMin}${this.unidadeLargura}`,
    minHeight: `${this.alturaMin}${this.unidadeAltura}`
  };

  if (this.larguraMax) {
    style.maxWidth = `${this.larguraMax}${this.unidadeLargura}`;
  }

  if (this.alturaMax) {
    style.maxHeight = `${this.alturaMax}${this.unidadeAltura}`;
  }

  return style;
}
</script>
